import { render, staticRenderFns } from "./addressFormatDialog.vue?vue&type=template&id=6ebbbd48&"
import script from "./addressFormatDialog.vue?vue&type=script&lang=js&"
export * from "./addressFormatDialog.vue?vue&type=script&lang=js&"
import style0 from "./addressFormatDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ebbbd48')) {
      api.createRecord('6ebbbd48', component.options)
    } else {
      api.reload('6ebbbd48', component.options)
    }
    module.hot.accept("./addressFormatDialog.vue?vue&type=template&id=6ebbbd48&", function () {
      api.rerender('6ebbbd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/addressFormatDialog.vue"
export default component.exports